module.exports = __webpack_public_path__ + "static/13-4b8c7347c74d046579337ca3df01ff36.jpg";